import { render, staticRenderFns } from "./TouchpointArrival.vue?vue&type=template&id=3f2d89c8&scoped=true&"
import script from "./TouchpointArrival.vue?vue&type=script&lang=js&"
export * from "./TouchpointArrival.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2d89c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f2d89c8')) {
      api.createRecord('3f2d89c8', component.options)
    } else {
      api.reload('3f2d89c8', component.options)
    }
    module.hot.accept("./TouchpointArrival.vue?vue&type=template&id=3f2d89c8&scoped=true&", function () {
      api.rerender('3f2d89c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/CanvasArea/Bricks/Settings/Touchpoint/TouchpointArrival.vue"
export default component.exports